
let SCORMToCollectValues: any = {};
let delay;

const SCORMToCollect = ($: object, key: null | string = null) => {

  const isHosted = (window as any).getParams().hosted;
  if (!isHosted) {
    return isHosted;
  }

  if (key) {
    SCORMToCollectValues = {
      ...SCORMToCollectValues,
      [key]: {
        ...SCORMToCollectValues[key],
        ...$,
      },
    };
  } else {
    SCORMToCollectValues = {
      ...SCORMToCollectValues,
      ...$,
    };
  }

  clearTimeout(delay);
  delay = setTimeout(() => {
    const raw = JSON.stringify({ hosting: { learning_module_session_data: SCORMToCollectValues } });

    const myHeaders = new Headers();
    myHeaders.append('Accept', 'application/json');
    myHeaders.append('Content-Type', 'application/json');

    const requestOptions: any = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const projectId = (window as any).getParams().projectId;

    const endPoint =
      `${window.chameleon.CHAMELEON_URL}/harp/hosting/${projectId}/data` ||
      `https://development.chameleoncreator.com/harp/hosting/${projectId}/data`;

    fetch(endPoint, requestOptions)
      .then(response => {
        // console.log({ response });
        return response.text();
      })
      .then(result => {
        console.log(result);
      })
      .catch(error => {
        console.log('error', error);
        console.log(raw);
      });
  }, 1000 / 60);
};

export default SCORMToCollect;
